import { render, staticRenderFns } from "./AdminCourses.vue?vue&type=template&id=6c4735c5&scoped=true"
import script from "./AdminCourses.vue?vue&type=script&lang=js"
export * from "./AdminCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4735c5",
  null
  
)

export default component.exports